import PropTypes from 'prop-types'
import { memo } from 'react'

import { APP_HREF } from '../../../../config'
import { Label } from '../../../Label'
import { Ticks } from '../../../Ticks'
import * as LABELS from '../../config/labels'
import { renderValue } from '../../lib/helpers'

import * as S from './styles'

export const ResultCapacityMain = memo(
  ({ capacity, duration, creditCost, onClickButton, payment, rate, ticks, ...props }) => {
    const secondaryLabels = [
      ['PAYMENT', payment],
      ['CREDIT_COST', creditCost],
      ['RATE', rate],
    ]

    const { suffix, ...labelCapacity } = LABELS.CAPACITY

    return (
      <S.Card {...props}>
        <S.Container>
          <Label {...labelCapacity} />

          <S.Highlight>
            {renderValue(capacity)} {suffix}
          </S.Highlight>
        </S.Container>

        <S.Status>{duration} ans</S.Status>

        <S.Divider />

        <S.Result>
          <ul>
            {secondaryLabels.map(([key, value]) => {
              const { roundTo, suffix, ...labelProps } = LABELS[key]

              return (
                <S.Row key={key}>
                  <Label {...labelProps} />

                  <S.Value>
                    {renderValue(value, roundTo)} <S.Suffix>{suffix}</S.Suffix>
                  </S.Value>
                </S.Row>
              )
            })}
          </ul>
        </S.Result>

        <S.Button href={APP_HREF} onClick={onClickButton}>
          Obtenir une estimation détaillée
        </S.Button>

        <Ticks ticks={ticks} />
      </S.Card>
    )
  }
)

ResultCapacityMain.propTypes = {
  capacity: PropTypes.number.isRequired,
  creditCost: PropTypes.number.isRequired,
  duration: PropTypes.number.isRequired,
  onClickButton: PropTypes.func.isRequired,
  payment: PropTypes.number.isRequired,
  rate: PropTypes.number.isRequired,
  ticks: PropTypes.arrayOf(PropTypes.string).isRequired,
}

ResultCapacityMain.displayName = 'ResultCapacityMain'
